module.exports = __webpack_public_path__ + "static/media/IMG_1904.816d0d27.JPG";